

















































import { Component, Vue, Watch } from "vue-property-decorator";
import { logout } from "@/req/user";
import { byRand } from "@/req/home";
import qs from "@/components/queSheng.vue";
@Component({ components: { qs } })
export default class Logout extends Vue {
  public nums = 0;
  public shows = false;
  public tagId = "";
  public versionId = "";
  public isShow = false;
  public data = [];
  // @Watch("$route")
  // public changeRoute() {
  //   if (this.$route.path == "/discover") {
  //     console.log(1)
  //   }
  // }
  public mounted() {
    this.getbyRand();
    window.addEventListener("scroll", this.add);
  }
  public destroyed() {
    window.removeEventListener("scroll", this.add);
  }
  @Watch("$store.state.discover.versions")
  public change() {
    this.versionId = this.$store.state.discover.versions;
    this.getbyRand();
  }
  @Watch("$store.state.discover.tag")
  public changes() {
    this.tagId = this.$store.state.discover.tag;
    this.getbyRand();
  }
  @Watch("$store.state.discover.search")
  public showChange() {
    this.shows = this.$store.state.discover.search;
  }
  public async getbyRand() {
    const obj = {
      token: this.$fn.cookies.getToken(),
      tag: this.tagId == null ? "" : this.tagId,
      versionid: this.versionId == null ? "" : this.versionId,
    };
    const res = await byRand(obj);
    if (res.code == 200) {
      if (res.data.gameList || res.data.gameList.length != 0) {
        this.data = res.data.gameList;
        this.nums = res.data.gameTotalNumber;
      }
    }
  }
  public getClear() {
    this.$store.state.discover.search = false;
    this.$store.state.discover.active = null;
    this.$store.state.discover.actives = null;
    this.$store.state.discover.tag = null;
    this.$store.state.discover.versions = null;
  }
  public add() {
    const a = document.documentElement.scrollTop;
    const b = document.documentElement.clientHeight;
    const c = document.documentElement.scrollHeight;
    if (c - a - b < 1) {
      if (this.nums > this.data.length) {
        this.getNewGameList();
      }
    }
  }
  public async getNewGameList() {
    const arr = this.data.map((item: any) => {
      return item.box_game_id;
    });
    const obj = {
      token: this.$fn.cookies.getToken(),
      tag: this.tagId == null ? "" : this.tagId,
      versionid: this.versionId == null ? "" : this.versionId,
      oldGameIdList: arr,
    };
    const res = await byRand(obj);
    if (res.code == 200) {
      if (res.data.gameList || res.data.gameList.length != 0) {
        const newArr: any = [...this.data, ...res.data.gameList];
        this.data = newArr;
        this.nums = res.data.gameTotalNumber;
      }
    }
  }
}
